<div class="fixed left-20 z-10" [ngClass]="{'top-34': mode() === RouteEditMode.ALTERATIONS && !newAlteration(), 'top-20': mode() === RouteEditMode.DESIGN}">
  <article id="commandsPanel" class="flex absolute gap-2 p-4 m-4 rounded-xl z-10 items-center justify-center">
    @if (mode() === RouteEditMode.DESIGN) {
      <div class="h-6 w-6 rounded">
        <img [src]="images.arrowLeft" class="p-1 cursor-pointer" (click)="goBack()" />
      </div>
      <div class="separator"></div>
      <section class="relative flex items-center gap-1">
        @if (routeStatusInfo()) {
          <div class="flex h-6 w-6 items-center justify-center" [tooltip]="routeStatusInfo()" [position]="TooltipPosition.BELOW">
            <img [src]="images.alterations.warningRoundFilled" class="h-4 w-4" alt="routeStatusInfo" />
          </div>
        }
        <div role="button" class="flex w-28 h-6 text-base font-semibold items-center justify-between rounded" [ngClass]="{'selected': routeStatusOpened, 'opacity-40 cursor-not-allowed': newRoute(), 'cursor-pointer': !newRoute()}" (click)="toggleRouteStatus()">
          <label class="ml-3 text-base font-semibold" [ngClass]="newRoute() ? 'cursor-not-allowed' : 'cursor-pointer'">
            {{ literalService.get("services.routes.design.routeStatus."+routeStatusSelected, true) }}
          </label>
          <img [src]="images.arrowDown" class="p-1 mr-2" [ngClass]="newRoute() ? 'cursor-not-allowed' : 'cursor-pointer'" />
        </div>
        @if (routeStatusOpened) {
        <section class="menu absolute top-8 z-10 bg-primary-purple-light-2 rounded-[10px] mt-2 p-2.5 flex flex-col gap-1.5">
          @for (item of routeStatuses(); track $index) {
            <div [ngClass]="{'cursor-not-allowed': item.disabled}">
              <div role="button" class="flex flex-row items-center gap-2 px-2 rounded cursor-pointer" [ngClass]="{'font-semibold': routeStatusSelected === item.value, 'disabled': item.disabled}" (click)="onChangeRouteStatus(item.value); routeStatusOpened = false">
                <div class="w-4 h-4 flex items-center p-0">
                  @if (routeStatusSelected === item.value) {
                    <img [src]="images.check" class="w-4 h-4" />
                  }
                </div>
                <span class="whitespace-nowrap">
                  {{ literalService.get("services.routes.design.routeStatus."+item.value, true) }}
                </span>
              </div>
            </div>
          }
        </section>
        }
      </section>
    }
    <section class="relative h-8 w-8 rounded">
      <div role="button" class="flex h-8 w-8 text-base font-semibold items-center justify-center cursor-pointer rounded" [ngClass]="{'selected': importOpened}" (click)="toggleImport()" [tooltip]="literalService.get('services.routes.design.tooltips.import', true)" [position]="TooltipPosition.BELOW" [shortcut]="utilsService.getShortcutText('i', true)">
        <img [src]="images.routes.import" class="p-1 cursor-pointer" />
      </div>
      @if (importOpened) {
      <section class="menu absolute z-10 bg-primary-purple-light-2 rounded-lg mt-2 p-4 flex flex-col gap-2">
        @for (item of importExportOptions; track $index) {
          <div role="button" class="flex flex-row items-center gap-2.5 px-2 rounded cursor-pointer border-neutrals-grey-01" (click)="import(item.value)">
            <span class="whitespace-nowrap">{{ literalService.get('services.routes.design.tooltips.import', true) }} {{ literalService.get(item.label) }}</span>
          </div>
        }
      </section>
      }
    </section>
    <input #importInput type="file" class="hidden" (change)="onImportFileSelected($event)" />
    @if (!newRoute()) {
      <section class="relative h-8 w-8 rounded">
        <div role="button" class="flex h-8 w-8 items-center justify-center cursor-pointer rounded" [ngClass]="{'selected': downloadOpened}" (click)="toggleDownload()" [tooltip]="literalService.get('services.routes.design.tooltips.download', true)" [position]="TooltipPosition.BELOW" [shortcut]="utilsService.getShortcutText('e', true)">
          <img [src]="images.download" class="p-1 cursor-pointer" />
        </div>
        @if (downloadOpened) {
        <section class="menu absolute z-10 bg-primary-purple-light-2 rounded-lg mt-2 p-4 flex flex-col gap-2">
          @for (item of importExportOptions; track $index) {
            <div role="button" class="flex flex-row items-center gap-2.5 px-2 rounded cursor-pointer border-neutrals-grey-01" (click)="download(item.value)">
              <span class="whitespace-nowrap">{{ literalService.get('services.routes.design.tooltips.download', true) }} {{ literalService.get(item.label) }}</span>
            </div>
          }
        </section>
        }
      </section>
    }
    <section class="relative h-8 w-8 rounded">
      <div class="h-8 w-8 rounded" [ngClass]="{'selected': confirmChangesModalShowed() || saveOpened, 'cursor-not-allowed': saveDisabled()}" [tooltip]="literalService.get('services.routes.design.tooltips.save', true)" [position]="TooltipPosition.BELOW" [shortcut]="utilsService.getShortcutText('s', true)">
        <img [src]="images.routes.save" class="p-1 cursor-pointer" [ngClass]="{'disabled': saveDisabled()}" (click)="toggleSave()" />
      </div>
      @if (saveBlockedByMissingSegments) {
        <app-warning-badge [label]="literalService.get('services.routes.stopsModal.connectAllStopsBeforeSave', true)" />
      }
      @if (saveOpened) {
      <section class="menu absolute z-10 bg-primary-purple-light-2 rounded-lg mt-2 p-4 flex flex-col gap-2">
        @for (item of saveActions; track $index) {
          <div role="button" class="flex flex-row items-center gap-2.5 px-2 rounded cursor-pointer border-neutrals-grey-01" (click)="triggerSave(item.value)">
            <span class="whitespace-nowrap">{{ literalService.get(item.label, true) }}</span>
          </div>
        }
      </section>
      }
    </section>
    <div class="separator"></div>
    <section class="relative h-8 w-8 rounded">
      <div role="button" class="flex h-8 text-base font-semibold items-center justify-between cursor-pointer rounded" [ngClass]="{'selected': mapConfigOpened}" (click)="config()" [tooltip]="literalService.get('services.routes.design.tooltips.mapConfig', true)" [position]="TooltipPosition.BELOW" [shortcut]="utilsService.getShortcutText('m', true)">
        <img [src]="images.routes.config" class="p-1 cursor-pointer" />
      </div>
      @if (mapConfigOpened) {
      <section class="menu absolute z-10 bg-primary-purple-light-2 rounded-lg mt-2 p-5 flex flex-col gap-6 min-w-96">
        <div class="flex justify-between">
          <span class="whitespace-nowrap text-lg font-bold">{{ literalService.get("services.routes.design.mapConfig.title", true) }}</span>
          <img [src]="images.close" class="w-6 h-6 cursor-pointer" (click)="closeMapConfig()" />
        </div>
        <div class="flex flex-col gap-4">
          <label class="font-bold text-base">{{ literalService.get("services.routes.design.mapConfig.view.title", true) }}</label>
          <div class="flex flex-row gap-4 items-center">
            <div class="bg-neutrals-white rounded w-full py-2 px-4 cursor-pointer">
              <label class="text-base flex flex-row items-center gap-2 cursor-pointer">
                <input class="radio radio-xs" type="radio" name="mapConfigView" [checked]="mapConfig.mapView === MapTypes.DEFAULT" (change)="updateMapConfig('mapView', MapTypes.DEFAULT)" />
                {{ literalService.get("services.routes.design.mapConfig.view.default", true) }}
              </label>
            </div>
            <div class="bg-neutrals-white rounded w-full py-2 px-4 cursor-pointer">
              <label class="text-base flex flex-row items-center gap-2 cursor-pointer">
                <input class="radio radio-xs" type="radio" name="mapConfigView" [checked]="mapConfig.mapView === MapTypes.SATELLITE" (change)="updateMapConfig('mapView', MapTypes.SATELLITE)" />
                {{ literalService.get("services.routes.design.mapConfig.view.satellite", true) }}
              </label>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-4">
          <label class="font-bold text-base">{{ literalService.get("services.routes.design.mapConfig.show.title", true) }}</label>
          <div class="flex flex-wrap gap-4 items-center">
            <div class="bg-neutrals-white rounded w-[calc(50%-0.5rem)] py-2 px-4 cursor-pointer">
              <app-checkbox
                [id]="'allStops'"
                [checked]="mapConfig.showAllStops"
                [value]="{name: literalService.get('services.routes.design.mapConfig.show.allStops', true)}"
                (onChange)="updateMapConfig('showAllStops', $event.target.checked)"
              />
            </div>
            <div class="rounded w-[calc(50%-0.5rem)] py-2 px-4" [ngClass]="{'disabled-bkg': mapConfig.showAllStops, 'bg-neutrals-white cursor-pointer': !mapConfig.showAllStops}">
              <app-checkbox
                [id]="'routeStops'"
                [checked]="mapConfig.showRouteStops"
                [value]="{name: literalService.get('services.routes.design.mapConfig.show.routeStops', true)}"
                [disabled]="mapConfig.showAllStops"
                (onChange)="updateMapConfig('showRouteStops', $event.target.checked)"
              />
            </div>
            <div class="bg-neutrals-white rounded w-[calc(50%-0.5rem)] py-2 px-4 cursor-pointer">
              <app-checkbox
                [id]="'startStop'"
                [checked]="mapConfig.showStartStop"
                [value]="{name: literalService.get('services.routes.design.mapConfig.show.startStop', true)}"
                (onChange)="updateMapConfig('showStartStop', $event.target.checked)"
              />
            </div>
            <div class="bg-neutrals-white rounded w-[calc(50%-0.5rem)] py-2 px-4 cursor-pointer">
              <app-checkbox
                [id]="'endStop'"
                [checked]="mapConfig.showEndStop"
                [value]="{name: literalService.get('services.routes.design.mapConfig.show.endStop', true)}"
                (onChange)="updateMapConfig('showEndStop', $event.target.checked)"
              />
            </div>
            <div class="bg-neutrals-white rounded w-[calc(50%-0.5rem)] py-2 px-4 cursor-pointer">
              <app-checkbox
                [id]="'segments'"
                [checked]="mapConfig.showSegments"
                [value]="{name: literalService.get('services.routes.design.mapConfig.show.segments', true)}"
                (onChange)="updateMapConfig('showSegments', $event.target.checked)"
              />
            </div>
            <div class="bg-neutrals-white rounded w-[calc(50%-0.5rem)] py-2 px-4 cursor-pointer">
              <app-checkbox
                [id]="'showNames'"
                [checked]="mapConfig.showNames"
                [value]="{name: literalService.get('services.routes.design.mapConfig.show.names', true)}"
                (onChange)="updateMapConfig('showNames', $event.target.checked)"
              />
            </div>
            <div class="bg-neutrals-white rounded w-[calc(50%-0.5rem)] py-2 px-4 cursor-pointer">
              <app-checkbox
                [id]="'showRadius'"
                [checked]="mapConfig.showRadius"
                [value]="{name: literalService.get('services.routes.design.mapConfig.show.radius', true)}"
                (onChange)="updateMapConfig('showRadius', $event.target.checked)"
              />
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-4">
          <label class="font-bold text-base">{{ literalService.get("services.routes.design.mapConfig.other.title", true) }}</label>
          <div class="flex flex-row gap-4 items-center">
            <div class="flex flex-row gap-2">
              <label>{{ literalService.get("services.routes.design.mapConfig.other.radius", true) }}</label>
              <div class="flex flex-row gap-1 items-center">
                <input type="number" [(ngModel)]="mapConfig.radius" class="w-10 h-5 rounded border border-neutrals-grey-03 p-2 bg-neutrals-white text-base" (keydown)="utilsService.blockInvalidRadiusKeys($event)" (change)="updateMapConfig('radius', $event.target.value)" [min]="APP.MIN_STOP_RADIUS" [max]="APP.MAX_STOP_RADIUS" step="1" />
              </div>
            </div>
            <div class="flex flex-row gap-2 items-center">
              <label>{{ literalService.get("services.routes.design.mapConfig.other.speed", true) }}</label>
              <div class="flex flex-row gap-1 items-center">
                <input type="number" [(ngModel)]="mapConfig.drivingSpeed" [disabled]="creationSegmentsType === CreationSegmentsType.AUTO" class="w-10 h-5 rounded border border-neutrals-grey-03 p-2 bg-neutrals-white text-base" (change)="updateMapConfig('drivingSpeed', $event.target.value)" min="0" />
              </div>
              @if (creationSegmentsType === CreationSegmentsType.AUTO) {
                <img class="w-4 h-4" [src]="images.info" alt="automatic creation info" [tooltip]="literalService.get('services.routes.design.mapConfig.other.speedAutomatic', true)" [position]="TooltipPosition.BELOW" />
              }
            </div>
          </div>
        </div>
      </section>
      }
    </section>
    @if (mode() === RouteEditMode.DESIGN) {
    <section class="relative h-8 w-8 rounded" [ngClass]="{'cursor-not-allowed': newRoute()}">
      <div role="button" class="flex h-8 items-center justify-center cursor-pointer rounded" [ngClass]="{'selected': alterationsOpened, 'disabled': newRoute()}" (click)="toggleAlterations()"  [tooltip]="`${literalService.get('services.routes.design.tooltips.alterations', true)}/${literalService.get('services.routes.design.tooltips.restrictions', true)}`" [position]="TooltipPosition.BELOW">
        <img [src]="images.routes.alternative" class="p-1 cursor-pointer" />
      </div>
      @if (alterationsOpened) {
      <section class="menu absolute z-10 bg-primary-purple-light-2 rounded-lg mt-2 p-4 flex flex-col gap-2">
        <div role="button" class="min-w-44 flex flex-row items-center gap-2 px-4 py-2 rounded cursor-pointer bg-neutrals-white border border-neutrals-grey-01" (click)="selectAlterations()">
          <span class="whitespace-nowrap">{{ literalService.get('services.routes.design.alterations', true) }}</span>
        </div>
        <div role="button" class="min-w-44 flex flex-row items-center gap-2 px-4 py-2 rounded cursor-pointer bg-neutrals-white border border-neutrals-grey-01" (click)="selectRestrictions()">
          <span class="whitespace-nowrap">{{ literalService.get('services.routes.design.restrictions', true) }}</span>
        </div>
      </section>
      }
    </section>
    }
    <div class="separator w-"></div>
    <section class="h-8 flex" >
      <div role="button" class="w-8 rounded" [ngClass]="{'selected': creationSegments}" (click)="changeCreationSegments(!creationSegments)" [tooltip]="literalService.get('services.routes.design.tooltips.createSegment', true)" [position]="TooltipPosition.BELOW" [shortcut]="utilsService.getShortcutText('d', true)">
        <img [src]="images.routes.createSegment[creationSegmentsType]" class="cursor-pointer" [ngClass]="{'p-1': creationSegmentsType === CreationSegmentsType.AUTO}" />
      </div>
      <section class="relative">
        <div role="button" class="flex h-8 w-4 text-base font-semibold items-center justify-center cursor-pointer rounded" [ngClass]="{'selected': creationSegmentsTypeOpened}" (click)="toggleCreationSegmentsType()" [tooltip]="literalService.get('services.routes.design.tooltips.createSegmentModes', true)" [position]="TooltipPosition.BELOW">
          <img [src]="images.arrowDown" class="w-2.5 h-2-5 cursor-pointer" />
        </div>
        @if (creationSegmentsTypeOpened) {
          <section class="menu absolute z-10 bg-primary-purple-light-2 rounded-[10px] mt-2 p-2.5 flex flex-col gap-1.5">
            @for (item of creationSegmentsTypeOptions; track $index) {
              <div role="button" class="flex flex-row items-center gap-2 px-2 rounded cursor-pointer" [ngClass]="{'font-semibold': creationSegmentsType === item.value}" (click)="changeCreationSegmentsType(item.value)">
                <div class="w-4 h-4 flex items-center p-0">
                  @if (creationSegmentsType === item.value) {
                    <img [src]="images.check" class="w-4 h-4" />
                  }
                </div>
                <span class="whitespace-nowrap">
                  {{ literalService.get("services.routes.design.creationSegmentsType."+item.value, true) }}
                </span>
              </div>
            }
          </section>
        }
      </section>
    </section>
    @if (mode() === RouteEditMode.DESIGN) {
      <div class="h-8 w-8 rounded">
        <div role="button" class="w-8 rounded" [ngClass]="{'selected-bkg': creationOutline}" (click)="changeCreationOutline(!creationOutline)" [tooltip]="literalService.get('services.routes.design.tooltips.outline', true)" [position]="TooltipPosition.BELOW" [shortcut]="utilsService.getShortcutText('o', true)">
          <img [src]="creationOutline ? images.routes.outlineSelected : images.routes.outline" class="p-1 cursor-pointer" />
        </div>
      </div>
    }
    <div class="h-8 w-8 rounded" [ngClass]="{'cursor-not-allowed': !(canUndo$ | async)}" [tooltip]="literalService.get('services.routes.design.tooltips.undo', true)" [position]="TooltipPosition.BELOW" [shortcut]="utilsService.getShortcutText('z', true)">
      <img [src]="images.routes.back" class="p-1 cursor-pointer" [ngClass]="{'disabled': !(canUndo$ | async)}" (click)="undo()" />
    </div>
    <div class="h-8 w-8 rounded" [ngClass]="{'cursor-not-allowed': !(canRedo$ | async)}" [tooltip]="literalService.get('services.routes.design.tooltips.redo', true)" [position]="TooltipPosition.BELOW" [shortcut]="utilsService.getShortcutText('z', true, true)">
      <img [src]="images.routes.forward" class="p-1 cursor-pointer" [ngClass]="{'disabled': !(canRedo$ | async)}" (click)="redo()" />
    </div>
    <div class="h-8 w-8 rounded" [ngClass]="{'cursor-not-allowed': selectedFeatures.length === 0}" [tooltip]="literalService.get('services.routes.design.tooltips.delete', true)" [position]="TooltipPosition.BELOW"  [shortcut]="utilsService.getShortcutText('Del', true)">
      <img [src]="images.routes.delete" class="p-1 cursor-pointer" [ngClass]="{'disabled': selectedFeatures.length === 0}" (click)="delete()" />
    </div>
  <div class="separator hidden"></div>
  <app-custom-toggle
    class="mr-2 hidden"
    [selectedValue]="designMode"
    [options]="designModeToggleOptions"
    [small]="true"
    (action)="{}"
  />
  </article>
  @if (selectedFeatures.length > 1) {
    <article id="legend" class="fixed bottom-0 flex m-4 p-2.5 justify-center items-center rounded-lg gap-2">
      <div class="flex flex-col gap-2 pl-1 pr-2">
        <div class="icon-container no-hover">
          <img [src]="images.info" class="w-6 h-6" />
        </div>
        <div class="icon-container" (click)="closeLegend()">
          <img [src]="images.arrowLeft" class="w-6 h-6" />
        </div>
      </div>
      <div class="item-with-separator flex gap-2 items-center">
        <div class="flex flex-row gap-2 items-center">
          @if (selectedType === FeatureType.STOP) {
            <label>{{ literalService.get("services.routes.design.legend.radius", true) }}</label>
            <div class="flex flex-row gap-1 items-center" [tooltip]="literalService.get('services.routes.design.legend.differentValues', true)" [position]="TooltipPosition.BELOW" [visibleTooltip]="!bulkRadius">
              <input type="number" [(ngModel)]="bulkRadius" [placeholder]="!bulkRadiusFocused && bulkRadius === null ? '-' : ''" (focus)="bulkRadiusFocused = true" (blur)="bulkRadiusFocused = false" (keydown)="utilsService.blockInvalidRadiusKeys($event)" class="w-10 h-5 rounded border border-neutrals-grey-03 p-2 bg-neutrals-white text-base" [min]="APP.MIN_STOP_RADIUS" [max]="APP.MAX_STOP_RADIUS" step="1" />
            </div>
          }
          @else {
            <label>{{ literalService.get("services.routes.design.legend.speed", false) }}</label>
            <div class="flex flex-row gap-1 items-center" [tooltip]="literalService.get('services.routes.design.legend.differentValues', true)" [position]="TooltipPosition.BELOW" [visibleTooltip]="!bulkDrivingSpeed">
              <input type="number" [(ngModel)]="bulkDrivingSpeed" [placeholder]="!bulkSpeedFocused && bulkDrivingSpeed === null ? '-' : ''" (focus)="bulkSpeedFocused = true" (blur)="bulkSpeedFocused = false" class="w-10 h-5 rounded border border-neutrals-grey-03 p-2 bg-neutrals-white text-base" min="0" />
            </div>
          }
          <button [disabled]="!bulkRadius && !bulkDrivingSpeed" class="text-neutrals-white bg-primary-purple font-normal! leading-normal px-2 py-1 rounded disabled:opacity-30 disabled:cursor-not-allowed!" (click)="applyBulkUpdate()">
            {{ literalService.get('apply', true) }}
          </button>
        </div>
      </div>
    </article>
  }
  @else if (!selectedLegendType) {
    <article id="legend" class="fixed bottom-0 flex m-4 justify-center items-center rounded-lg">
      <div class="icon-container p-2.5 pr-1" (click)="selectLegendType(LegendTypes.STOPS)" [tooltip]="literalService.get('services.routes.design.tooltips.info', true)" [visibleTooltip]="true" [position]="TooltipPosition.ABOVE">
        <img [src]="images.info" class="w-6 h-6" />
      </div>
      <div class="relative">
        <div class="icon-container p-2.5 pl-1" [ngClass]="{'hover': showLegendDropdown}" (click)="showLegendDropdown = !showLegendDropdown" [tooltip]="literalService.get('services.routes.design.tooltips.infoArrow', true)" [visibleTooltip]="true" [position]="TooltipPosition.ABOVE">
          <img [src]="images.arrowDown" class="w-6 h-6 p-1"/>
        </div>
        <div class="legend-menu shadow-menu absolute bottom-12 z-10 cursor-pointer rounded-lg flex flex-col gap-1.5 py-2 whitespace-nowrap" [ngClass]="{'hidden': !showLegendDropdown,}">
          <div class="p-0" [ngClass]="{'cursor-not-allowed': alterationPreviewDisabled()}">
            <div [ngClass]="{'disabled': alterationPreviewDisabled()}" (click)="selectLegendType(LegendTypes.AFFECTED_RESERVATIONS)">
              {{ literalService.get('services.routes.design.legend.show.affectedReservations', true) }}
            </div>
          </div>
          <div (click)="selectLegendType(LegendTypes.TIMES)">{{ literalService.get('services.routes.design.legend.show.times', true) }}</div>
        </div>
      </div>
    </article>
  }
  @else {
    <article id="legend" class="fixed bottom-0 flex m-4 p-2.5 justify-center items-center rounded-lg gap-2">
      @if (selectedLegendType === LegendTypes.STOPS || selectedLegendType === LegendTypes.STOP_INFO) {
        <div class="flex flex-col gap-2 pl-1 pr-2">
          <div class="icon-container no-hover">
            <img [src]="images.info" class="w-6 h-6" />
          </div>
          @if (selectedLegendType === LegendTypes.STOPS) {
            <div class="icon-container" (click)="closeLegend()">
              <img [src]="images.arrowLeft" class="w-7 h-7 p-1" />
            </div>
          }
        </div>
        <div class="item-with-separator pl-3 flex flex-row gap-4 items-center">
          @for (type of stopTypes; track $index) {
            @if (type.visible) {
              <div class="flex flex-row gap-2 items-center cursor-pointer" (click)="selectStopType(type.id)" [tooltip]="literalService.get(`services.routes.design.tooltips.stopsInfo.${type.id}`, true)" [position]="TooltipPosition.ABOVE">
                <img [src]="isStopTypeChecked(type.id) ? type.imgSelected : type.img" class="w-7 h-7" />
              </div>
            }
          }
          @if (selectedLegendType === LegendTypes.STOP_INFO && (isStopTypeVisible(StopType.ALTERNATIVES) || isStopTypeVisible(StopType.ALTERNATIVE_OF))) {
            <div class="flex flex-row gap-4 items-center">
              @if (isStopTypeVisible(StopType.ALTERNATIVES)) {
                <label class="flex flex-row gap-2 items-center cursor-pointer">
                  <input type="radio" name="stopTypeGroup" class="radio w-4 h-4 cursor-pointer" [class.selected]="isStopTypeChecked(StopType.ALTERNATIVES)" [value]="StopType.ALTERNATIVES" [ngModel]="selectedStopSubType" (change)="selectStopType(StopType.ALTERNATIVES)" />
                  {{ literalService.get('services.routes.design.legend.alternatives', true)}}
                </label>
              }
              @if (isStopTypeVisible(StopType.ALTERNATIVE_OF)) {
                <label class="flex flex-row gap-2 items-center cursor-pointer">
                  <input type="radio" name="stopTypeGroup" class="radio w-4 h-4 cursor-pointer" [class.selected]="isStopTypeChecked(StopType.ALTERNATIVE_OF)" [value]="StopType.ALTERNATIVE_OF" [ngModel]="selectedStopSubType" (change)="selectStopType(StopType.ALTERNATIVE_OF)" />
                  {{ literalService.get('services.routes.design.legend.alternativeOf', true)}}
                </label>
              }
            </div>
          }
        </div>
      }
      @else if (selectedLegendType === LegendTypes.AFFECTED_RESERVATIONS) {
        <div class="relative">
          <div class="icon-container" (click)="closeLegend()">
            <img [src]="images.arrowLeft" class="w-7 h-7 p-1" />
          </div>
          <div class="legend-menu rounded-lg absolute left-10 -bottom-2 p-6">
            <app-route-design-preview
              [routes]="previewChanges()"
              [loadingBookings]="loadingPreview()"
            />
          </div>
        </div>
      }
      @else if (selectedLegendType === LegendTypes.TIMES) {
        <div class="flex flex-col gap-2 pl-1 pr-2">
          <div class="icon-container" (click)="closeLegend()">
            <img [src]="images.arrowLeft" class="w-7 h-7 p-1" />
          </div>
          <div class="icon-container no-hover">
            <img [src]="images.routes.times" class="w-6 h-6" />
          </div>
        </div>
        <div class="flex gap-2">
          <div class="item-with-separator flex flex-col justify-center">
            <div>{{ literalService.get('services.routes.design.legend.maxVariability', true) }}</div>
            @if (loadingRouteTimes) {
              <article class="flex w-full justify-start">
                <ng-lottie class="w-5" height="100%" width="100%" [options]="loadingAnimation" (animationCreated)="utilsService.animationCreated($event, 1)" />
              </article>
            }
            @else {
              <div class="font-semibold">{{ getFormattedTime(routeTimes?.maxVariability) }}</div>
            }
          </div>
          <div class="item-with-separator flex flex-col justify-center">
            <div>{{ literalService.get('services.routes.design.legend.maxRouteTime', true) }}</div>
            @if (loadingRouteTimes) {
              <article class="flex w-full justify-start">
                <ng-lottie class="w-5" height="100%" width="100%" [options]="loadingAnimation" (animationCreated)="utilsService.animationCreated($event, 1)" />
              </article>
            }
            @else {
              <div class="font-semibold" [ngClass]="{ 'text-red-600': coverageExceedsMaxTime }">{{ getFormattedTime(routeTimes?.maxPathTime) }}</div>
              @if (coverageExceedsMaxTime) {
                <div class="text-xs text-red-600">{{ literalService.get('services.routes.design.legend.maxRouteTimeExceedsMaxTime', true) }}</div>
              }
            }
          </div>
          <div class="item-with-separator flex flex-col justify-center">
            <div>{{ literalService.get('services.routes.design.legend.minRouteTime', true) }}</div>
            @if (loadingRouteTimes) {
              <article class="flex w-full justify-start">
                <ng-lottie class="w-5" height="100%" width="100%" [options]="loadingAnimation" (animationCreated)="utilsService.animationCreated($event, 1)" />
              </article>
            }
            @else {
              <div class="font-semibold">{{ getFormattedTime(routeTimes?.minPathTime) }}</div>
            }
          </div>
        </div>
      }
    </article>
  }
</div>
<div class="fixed z-20 hidden border rounded-[5px] py-1.5 [box-shadow:0_4px_4px_0_rgba(0,0,0,0.15)] bg-white" id="menu">
  <div id="addStop" class="menu-item px-2.5 cursor-pointer">{{ literalService.get('services.routes.design.actions.addStop', true) }}</div>
  @if (eventsOptions.areaInMenu) {
    <div id="renameArea" class="menu-item px-2.5 cursor-pointer" (click)="renameAreaFromMenu()">{{ literalService.get('services.routes.design.area.rename', true) }}</div>
    <div id="deleteArea" class="menu-item px-2.5 cursor-pointer text-secondary-red" (click)="showDeleteAreaModal()">{{ literalService.get('services.routes.design.area.delete', true) }}</div>
  }
</div>
<div class="fixed z-20 hidden border rounded-[5px] py-1.5 [box-shadow:0_4px_4px_0_rgba(0,0,0,0.15)] bg-white" id="menu-segments">
  <div id="editSegment" class="menu-item px-2.5 cursor-pointer" (click)="eventsOptions.editWaypointsSegment()">{{ literalService.get('services.routes.design.actions.segment.editWaypoints', true) }}</div>
  <div id="setWaypoints" class="menu-item px-2.5 cursor-pointer" (click)="eventsOptions.redrawSegment()">{{ literalService.get('services.routes.design.actions.segment.redraw', true) }}</div>
</div>
<div class="fixed z-20 hidden flex-col border rounded-[5px] py-1.5 [box-shadow:0_4px_4px_0_rgba(0,0,0,0.15)] bg-white" id="menu-stops">
  @for (action of stopActions; track $index) {
    <div class="flex flex-row gap-2 px-2.5 items-center menu-item cursor-pointer" (click)="onStopAction(action.id)">
      <img [src]="action.img" class="w-4 h-4" />
      {{ literalService.get(action.label, true) }}
    </div>
  }
  @if (unsetStopActions.length > 0) {
    <div class="divider my-0 px-2.5"></div>
    @for (action of unsetStopActions; track $index) {
      <div class="flex flex-row gap-2 px-2.5 items-center menu-item cursor-pointer text-secondary-red" (click)="onStopAction(action.id)">
        <img [src]="action.img" class="w-4 h-4" alt="undoActionIcon"/>
        {{ literalService.get(action.label, true) }}
      </div>
    }
  }
</div>
<div class="fixed z-20 hidden border rounded-[5px] py-1.5 [box-shadow:0_4px_4px_0_rgba(0,0,0,0.15)] bg-white" id="menu-stop-alternative">
  <div id="removeAlternative" class="flex flex-row gap-2 px-2.5 items-center menu-item cursor-pointer text-secondary-red">
    <img [src]="images.cancelCircle" class="w-4 h-4" alt="undoActionIcon"/>
    {{ literalService.get('services.routes.design.actions.stop.removeAlternative', true) }}
  </div>
</div>
<div class="fixed z-20 hidden flex-col border rounded-[5px] py-1.5 [box-shadow:0_4px_4px_0_rgba(0,0,0,0.15)] bg-white" id="menu-box-select">
  <div id="deleteBoxStops" class="menu-item px-2.5 cursor-pointer" (click)="eventsOptions.deleteBoxSelectedStops()">{{ literalService.get('services.routes.design.actions.boxSelection.deleteStops', true) }}</div>
  <div id="deleteBoxSegments" class="menu-item px-2.5 cursor-pointer" (click)="eventsOptions.deleteBoxSelectedSegments()">{{ literalService.get('services.routes.design.actions.boxSelection.deleteSegments', true) }}</div>
  <div id="deleteBoxAll" class="menu-item px-2.5 cursor-pointer text-secondary-red" (click)="eventsOptions.deleteBoxSelectedAll()">{{ literalService.get('services.routes.design.actions.boxSelection.deleteAll', true) }}</div>
</div>
<app-route-design-modal
  class="fixed z-10 transition-all duration-300 mt-20"
  [class.hidden]="detailsWidth() >= 800"
  [ngClass]="{'top-19': mode() === RouteEditMode.ALTERATIONS && !newAlteration(), 'top-5': mode() === RouteEditMode.DESIGN || (mode() === RouteEditMode.ALTERATIONS && newAlteration())}"
  [style.right.px]="detailsWidth() + 20"
  [type]="selectedType"
  [list]="featureList"
  [selectedItems]="selectedFeatures"
  [creationSegments]="creationSegments"
  [mode]="mode()"
  [showAreas]="showAreasTab"
  [showOrderedStops]="showOrderedStopsTab"
  [orderedStopsTownStops]="orderedStopsTownStops()"
  [orderedStopsTownCenter]="orderedStopsTownCenter()"
  [orderedStopsApplying]="orderedStopsApplying()"
  [orderedStopsInitialRows]="orderedStopsInitialRows"
  [orderedStopsSelectedStopIds]="orderedStopsSelectedStopIds"
  [orderedStopsPathType]="orderedStopsPathType"
  [allowReorderStops]="allowReorderStops"
  [orderedStopsRevealMissingSegmentsRequest]="orderedStopsRevealMissingSegmentsRequest()"
  (onChangeSelectionType)="initModalData($event)"
  (onClickSelectedItem)="onClickSelectedItem($event)"
  (onEditSelectedItem)="onEditSelectedItem($event)"
  (orderedStopsConfirm)="onOrderedStopsConfirm($event)"
  (orderedStopsSelect)="onOrderedStopsSelect($event)"
  (orderedStopsPathTypeChange)="onOrderedStopsPathTypeChange($event)"
></app-route-design-modal>
<app-modal-confirmation
  [id]="'deleteAreaAlert'"
  [modal]="deleteAreaModal"
  [title]="'services.routes.design.area.delete'"
  [text]="deleteAreaText"
  [sameLineButtons]="true"
  [hidden]="!deleteAreaModalShowed"
  (cancelAction)="deleteAreaModal.hide()"
  (action)="confirmDeleteArea()"
/>
<app-modal-confirmation
  [id]="'sharedStopAlert'"
  [modal]="sharedStopModal"
  [shown]="sharedStopModalShowed"
  [title]="'services.routes.design.actions.update.sharedStop.title'"
  [text]="'services.routes.design.actions.update.sharedStop.description'"
  [sameLineButtons]="true"
  [extraInfoCheckbox]="'services.routes.design.actions.update.sharedStop.doNotShowAgain'"
  [hidden]="!sharedStopModalShowed"
  (cancelAction)="hideSharedStopAlert(true)"
  (action)="confirmSharedStop($event)"
/>
<app-modal-confirmation
  [id]="'stopInUseAlert'"
  [modal]="stopInUseModal"
  [shown]="stopInUseModalShowed"
  [icon]="images.alert"
  [title]="'services.routes.design.actions.update.stopInUse.title'"
  [text]="stopInUseText"
  [htmlText]="true"
  [sameLineButtons]="true"
  [hideCancelButton]="stopInUseOnlyBlocked"
  [confirmText]="stopInUseOnlyBlocked ? 'accept' : 'services.routes.design.actions.update.stopInUse.confirm'"
  [hidden]="!stopInUseModalShowed"
  (cancelAction)="cancelStopInUse()"
  (action)="confirmStopInUse()"
/>
